import React from 'react';
import PropTypes from 'prop-types';
import {Container, Menu} from 'semantic-ui-react';
import {addThousandsCommas, clamp, clone, range} from 'utils/DBUtils';
import {injectIntl, intlShape} from 'react-intl';

const PagingBarView = (props) => {
  const numPages = props.count;
  const lessThanMax = props.currentPage < Math.abs(numPages - props.maxPages);
  const maxPageNumber = props.currentPage + (props.maxPages);
  const minPageNumber = 1;
  const upperPageRange = clamp(maxPageNumber, minPageNumber, numPages);

  // Use current page for min in range if we only have enough pages to show the max pages
  // Else use maxPages less than numPages
  const upperRangeMinPageNumber = numPages <= props.maxPages + 1 ?
      props.currentPage
      : clamp(Math.abs(numPages-props.maxPages), 1, Math.abs(numPages-props.maxPages));

//   console.log(`\
// currentPage: ${props.currentPage}
// numPages: ${numPages}
// maxPages: ${props.maxPages}
// lessThanMax: ${lessThanMax}
// maxPageNumber: ${maxPageNumber}
// minPageNumber: ${minPageNumber}
// upperPageRange: ${upperPageRange}
// lessRange: ${range(props.currentPage, upperPageRange)}
// upperRangeMinPageNumber: ${upperRangeMinPageNumber}
// greaterRange: ${range(upperRangeMinPageNumber, numPages + 1)}
// `);
  return (
        <section className="db-paging-bar">
            {props.numOfItemsOnPage != 0 ?
                <Menu pagination>
                    <Menu.Item name={props.intl.formatMessage({id: 'previous'})}
                               key={props.intl.formatMessage({id: 'previous'})}
                               disabled={props.currentPage === 1}
                               onClick={() => props.onPreviousClicked(props.currentPage)}/>



                    {props.currentPage > 2 && numPages !== props.maxPages ? /*Shows '1...' if we're past page 1*/
                        range(1,2).map((item) => (
                            <Menu.Item name={`${1}`}
                                       key={1}
                                       onClick={() => props.onPageSelected(1)}/>
                        )).concat(
                            [
                                <Menu.Item disabled>...</Menu.Item>,
                            ]
                        ) : ""
                    }

                    {props.currentPage == 2 ?
                        <Menu.Item name={`${1}`}
                                   key={1}
                                   onClick={() => props.onPageSelected(1)}/>
                        : ""
                    }


                    {/*Shows our currentPage on the left and the next 9 pages after it.*/
                        lessThanMax ? //Less than Max?
                            range(props.currentPage, upperPageRange).map((item, index) => (
                                <Menu.Item name={`${item}`}
                                           key={item}
                                           disabled={props.currentPage === item}
                                           className={"db-button-rainbow-"+(index)}
                                           onClick={() => props.onPageSelected(item)}/>
                            )).concat(
                                [
                                    numPages > props.maxPages ? <Menu.Item disabled>...</Menu.Item> : "",
                                    <Menu.Item name={`${numPages}`}
                                               key={numPages}
                                               disabled={props.currentPage === numPages}
                                               onClick={() => props.onPageSelected(numPages)}/>
                                ]
                            ) :
                            range(upperRangeMinPageNumber, numPages + 1).map((item,index) => (
                                <Menu.Item name={`${item}`}
                                           key={item}
                                           disabled={props.currentPage === item}
                                           className={"db-button-rainbow-"+index}
                                           onClick={() => props.onPageSelected(item)}/>
                            ))

                    }

                    <Menu.Item name={props.intl.formatMessage({id: 'next'})}
                               key={props.intl.formatMessage({id: 'next'})}
                               disabled={props.currentPage === numPages}
                               onClick={() => props.onNextClicked(props.currentPage)}/>

                </Menu>
                :""}
            <Container fluid className="db-table-results">
                <p>{addThousandsCommas(props.total) + " "}{props.intl.formatMessage({id: 'results'})} </p>
            </Container>
        </section>
    );
}

export const propShape = {
  intl: intlShape,
  count: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageSelected: PropTypes.func.isRequired,
  onNextClicked: PropTypes.func,
  onPreviousClicked: PropTypes.func,
  maxPages: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  numOfItemsOnPage: PropTypes.number.isRequired
};

PagingBarView.propTypes = propShape;

class PagingBar extends React.Component {

  render() {
    let newProps = clone(this.props);
    if (newProps.count <= 0 || newProps.numOfItemsOnPage == 0) {
      newProps.count = 1;
      newProps.total = 0;
    }

    return <PagingBarView {...newProps}/>;
  }
}

PagingBar.propTypes = PagingBarView.propTypes;

export default injectIntl(PagingBar);



// WEBPACK FOOTER //
// ./public/components/common/PagingBar.jsx